<script lang="ts">
  import { _ } from 'svelte-i18n';

  import Label from '../typography/Label.svelte';
  import Text from '../typography/Text.svelte';

  import Link from './Link.svelte';

  import { AppState, ToastQueue } from '../../etc/stores';

  import { Container } from '../../services/container';
  import { WidgetConnect } from '../../services/widget-connect';
  import { Logger } from '../../services/logger';
  import { Auth } from '../../services/auth';
  import { extractMessageFromError } from '../../services/api';
  import Spinner from './Spinner.svelte';
  import EmailInbox from '../icons/EmailInbox.svelte';
  import GradientBackground from '../icons/GradientBackground.svelte';
  import { replaceVariables } from '../../i18n';
  import { onMount } from 'svelte';
  import Analytics from '../../services/analytics';

  const email = $AppState.customer.mail;

  let loading = false;

  const connect = Container.get(WidgetConnect);
  const auth = Container.get(Auth);
  const logger = Container.get(Logger).context(
    'FinishSignInModal.svelte'
  ) as Logger;

  const { providerData: customer } = $AppState.auth;

  const t = (text: string, values?: any) => {
    return replaceVariables($_(`finish-signin-modal.${text}`), values);
  };

  const onResendEmail = async () => {
    if (loading) return;
    loading = true;
    await onSendEmail();
    loading = false;
  };

  const onSendEmail = async () => {
    try {
      const { account } = await auth.getAuthState();
      await connect.resendEmail(auth.provider, {
        account,
        email: email || customer?.email
      });
      ToastQueue.add({
        title: t('send_success.title'),
        message: t('send_success.message'),
        type: 'success',
        duration: 1500
      });
    } catch (e) {
      logger.error(e);
      ToastQueue.add({
        title: $_('error.title'),
        message: extractMessageFromError(e),
        type: 'error',
        duration: 5000
      });
    }
  };

  onMount(() => {
    Analytics.logEvent('soft-signup-state', 'modal-create-password-trigger');
  });
</script>

<div class="finish-signin">
  <div class="finish-signin__image">
    <div class="finish-signin__background">
      <GradientBackground />
    </div>
    <div class="finish-signin__inbox">
      <EmailInbox hideBackground />
    </div>
  </div>
  <Label
    component="p"
    type="default-regular"
    textAlign="center"
    class="finish-signin__title"
  >
    {@html t('title', { EMAIL: email })}
  </Label>
  <div class="finish-signin__footer">
    <Text
      component="p"
      type="medium"
      textAlign="center"
      color={`${$AppState.theme.colors.typography}90`}
      class="finish-signin__disclaimer"
    >
      {t('disclaimer')}
    </Text>
    <div class="finish-signin__footer-link">
      {#if loading}
        <Spinner
          width="16px"
          height="16px"
          color={$AppState.theme.colors.primary}
        />
      {:else}
        <Link
          on:click={() => onResendEmail()}
          width="auto"
          fontSize="14px"
          lineHeight="24px">{t('resend')}</Link
        >
      {/if}
    </div>
  </div>
</div>

<style lang="scss">
  .finish-signin {
    width: 294px;
    height: 388px;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;

    &__footer {
      display: flex;
      align-self: center;
      margin-bottom: 32px;

      &-link {
        width: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &__image {
      position: absolute;
      top: 0;
      pointer-events: none;

      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 175px;
    }
    &__background {
      position: absolute;
      top: -70px;
      left: -49px;
    }

    &__inbox {
      transform: translateY(14px) translateX(-4px);
    }
  }

  :global(.finish-signin__title) {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-self: center;
    margin-top: 180px !important;
    line-height: 24px !important;
    align-items: center;
    padding: 0px 20px !important;
    max-width: calc(100% - 24px);
    overflow-wrap: break-word !important;
  }

  :global(.finish-signin__title b) {
    font-size: 14px !important;
  }

  :global(.finish-signin__disclaimer) {
    margin-right: 4px !important;
    line-height: 24px !important;
  }
</style>
